import {
  Bars3Icon,
  BookmarkSquareIcon,
  BriefcaseIcon,
  GlobeAltIcon,
  InformationCircleIcon,
  NewspaperIcon,
  PhoneIcon,
  PlayIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  XMarkIcon,
  Cog6ToothIcon,
  CurrencyDollarIcon,
  LightBulbIcon,
  WrenchScrewdriverIcon,
  MapIcon,
  BookOpenIcon,
  EnvelopeIcon,
  EnvelopeOpenIcon,
  MapPinIcon,
  PaperAirplaneIcon,
  CalendarDaysIcon,
  HandRaisedIcon,
  QuestionMarkCircleIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ArrowRightIcon,
  ClockIcon,
  ArrowDownTrayIcon,
  ChartBarSquareIcon,
  CircleStackIcon,
  DocumentTextIcon,
  ScaleIcon,
  SparklesIcon,
  ChatBubbleLeftRightIcon,
  MagnifyingGlassIcon,
  MinusIcon,
  PlusIcon,
  CpuChipIcon,
  CurrencyEuroIcon,
  BanknotesIcon,
  CreditCardIcon,
  LockClosedIcon,
  ArrowUpRightIcon,
  ArrowTrendingUpIcon,
} from '@heroicons/react/24/outline'
import {
  ChevronUpIcon,
  ArrowLeftIcon,
  CheckIcon,
  ChevronUpDownIcon,
  PaperClipIcon,
  CheckCircleIcon,
  XCircleIcon,
  ArrowPathIcon,
  HomeIcon,
  RocketLaunchIcon,
  UserIcon,
  CalendarIcon,
  ClipboardIcon,
  UserPlusIcon,
} from '@heroicons/react/20/solid'
import { StarIcon } from '@heroicons/react/24/solid'

export const HeroIcons = {
  ClipboardIcon,
  Bars3Icon,
  BookmarkSquareIcon,
  BriefcaseIcon,
  GlobeAltIcon,
  InformationCircleIcon,
  NewspaperIcon,
  PhoneIcon,
  PlayIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  UserPlusIcon,
  XMarkIcon,
  Cog6ToothIcon,
  CurrencyDollarIcon,
  LightBulbIcon,
  WrenchScrewdriverIcon,
  MapIcon,
  BookOpenIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
  ChevronRightIcon,
  CheckIcon,
  ChevronUpDownIcon,
  PaperClipIcon,
  EnvelopeIcon,
  EnvelopeOpenIcon,
  MapPinIcon,
  PaperAirplaneIcon,
  CheckCircleIcon,
  XCircleIcon,
  ArrowPathIcon,
  HomeIcon,
  RocketLaunchIcon,
  UserIcon,
  CalendarIcon,
  ClockIcon,
  CalendarDaysIcon,
  HandRaisedIcon,
  QuestionMarkCircleIcon,
  ArrowDownTrayIcon,
  ChartBarSquareIcon,
  CircleStackIcon,
  DocumentTextIcon,
  ScaleIcon,
  SparklesIcon,
  ChatBubbleLeftRightIcon,
  MagnifyingGlassIcon,
  MinusIcon,
  PlusIcon,
  CpuChipIcon,
  CurrencyEuroIcon,
  BanknotesIcon,
  CreditCardIcon,
  LockClosedIcon,
  ArrowUpRightIcon,
  ArrowTrendingUpIcon,
  StarIcon,
}
